import classnames from "classnames/bind";
import styles from "./AdditionalMessage.module.scss";

const cx = classnames.bind(styles);

type Props = {
  /**
   * An array of messages to be displayed by the component.
   */
  messages: string[];
  /**
   * A boolean indicating whether the new typography styles should be applied.
   */
  isNewTypographyEnabled: boolean;
};

export const AdditionalMessageUI = ({
  messages,
  isNewTypographyEnabled,
}: Props) => {
  if (messages.length === 0) {
    return null;
  }

  return (
    <p
      data-testid="product:additional-message"
      data-component="AdditionalMessage"
      className={cx("message", { newTypography: isNewTypographyEnabled })}
    >
      {messages[0]}
    </p>
  );
};
